<script>
import MetisMenu from "metismenujs/dist/metismenujs";

export default {
  components: {},
  data() {
    return {
      menus: [],
      submenus: [],
      subMenuLength: [],
    };
  },
  mounted: function () {
    const sidebarLayout = localStorage.getItem("sidebar-layout");
    switch (sidebarLayout) {
      case "light-sidebar":
        this.lightSidebar();
        break;
      case "compact-sidebar":
        this.compactSidebar();
        break;
      case "icon-sidebar":
        this.iconSidebar();
        break;
      case "colored-sidebar":
        this.coloredSidebar();
        break;
      case "boxed-layout":
        this.boxedLayout();
        break;
      default:
        document.body.setAttribute("data-sidebar", "dark");
        break;
    }
    var menus = JSON.parse(localStorage.getItem("menus"));
    var menuArray = [];
    var subMenuArray = [];
    var subMenuLength = {};

    for (var i = 0; i < menus.length; i++) {
      if (menus[i].parent_id === 0) {
        menuArray.push(menus[i]);
      } else {
        subMenuArray.push(menus[i]);
        subMenuLength[menus[i].parent_id] = 0;
        subMenuLength[menus[i].parent_id] =
          subMenuLength[menus[i].parent_id] == undefined
            ? 0
            : parseInt(subMenuLength[menus[i].parent_id]) + 1;
      }
    }

    this.menus = menuArray;
    this.submenus = subMenuArray;
    this.subMenuLength = subMenuLength;
  },
  methods: {
    defaultSidebar() {
      localStorage.setItem("sidebar-layout", "default-sidebar");
      document.body.setAttribute("data-sidebar", "dark");
      document.body.removeAttribute("data-layout-size", "boxed");
      document.body.removeAttribute("data-sidebar-size", "small");
      document.body.removeAttribute("data-topbar", "small");
      document.body.classList.remove("vertical-collpsed");
    },
    lightSidebar() {
      localStorage.setItem("sidebar-layout", "light-sidebar");
      document.body.setAttribute("data-topbar", "dark");
      document.body.removeAttribute("data-sidebar");
      document.body.removeAttribute("data-layout-size", "boxed");
      document.body.removeAttribute("data-sidebar-size", "small");
      document.body.classList.remove("vertical-collpsed");
    },
    compactSidebar() {
      localStorage.setItem("sidebar-layout", "compact-sidebar");
      document.body.setAttribute("data-sidebar-size", "small");
      document.body.setAttribute("data-sidebar", "dark");
      document.body.removeAttribute("data-layout-size", "boxed");
      document.body.classList.remove("vertical-collpsed");
      document.body.removeAttribute("data-topbar", "dark");
    },
    iconSidebar() {
      localStorage.setItem("sidebar-layout", "icon-sidebar");
      document.body.setAttribute("data-keep-enlarged", "true");
      document.body.classList.add("vertical-collpsed");
      document.body.setAttribute("data-sidebar", "dark");
      document.body.removeAttribute("data-topbar", "dark");
      document.body.removeAttribute("data-layout-size", "boxed");
    },
    boxedLayout() {
      localStorage.setItem("sidebar-layout", "boxed-layout");
      document.body.setAttribute("data-keep-enlarged", "true");
      document.body.classList.add("vertical-collpsed");
      document.body.setAttribute("data-layout-size", "boxed");
      document.body.removeAttribute("data-sidebar", "colored");
      document.body.setAttribute("data-sidebar", "dark");
      document.body.removeAttribute("data-topbar", "dark");
    },
    coloredSidebar() {
      localStorage.setItem("sidebar-layout", "colored-sidebar");
      document.body.setAttribute("data-sidebar", "colored");
      document.body.removeAttribute("data-layout-size", "boxed");
      document.body.removeAttribute("data-sidebar-size", "small");
      document.body.classList.remove("vertical-collpsed");
    },
  },
  updated: function () {
    this.$nextTick(function () {
      // eslint-disable-next-line no-unused-vars
      var menuRef = new MetisMenu("#side-menu");
      var links = document.getElementsByClassName("side-nav-link-ref");
      var matchingMenuItem = null;
      var onlyParent = null;
      var route = window.location.href.split("#");

      for (var i = 0; i < links.length; i++) {
        if ("#" + route[1] === links[i].hash) {
          matchingMenuItem = links[i];
          break;
        }
      }

      if (matchingMenuItem == null) {
        for (var i = 0; i < links.length; i++) {
          var splitRoute = route[1].split("/");
          var splitLink = links[i].hash.split("/");
          if (splitRoute[1] == splitLink[1]) {
            onlyParent = links[i];
            break;
          }
        }
      }

      if (matchingMenuItem && !onlyParent) {
        matchingMenuItem.classList.add("active");
        var parent = matchingMenuItem.parentElement;

        /**
         * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
         * We should come up with non hard coded approach
         */
        if (parent) {
          parent.classList.add("mm-active");
          const parent2 = parent.parentElement.closest("ul");
          if (parent2 && parent2.id !== "side-menu") {
            parent2.classList.add("mm-show");
            const parent3 = parent2.parentElement;
            if (parent3) {
              parent3.classList.add("mm-active");
              var childAnchor = parent3.querySelector(".has-arrow");
              var childDropdown = parent3.querySelector(".has-dropdown");
              if (childAnchor) childAnchor.classList.add("mm-active");
              if (childDropdown) childDropdown.classList.add("mm-active");

              const parent4 = parent3.parentElement;
              if (parent4) parent4.classList.add("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5) parent5.classList.add("mm-active");
            }
          }
        }
      } else if (!matchingMenuItem && onlyParent) {
        var parent = onlyParent.parentElement;
        const parent2 = parent.parentElement.closest("ul");
        const parent3 = parent2.parentElement.closest("li");
        const parent4 = parent3.firstElementChild;
        parent4.classList.add("mm-active");
      }
    });
  },
  computed: {
    searchInLowerCase() {
      return this.search
        .replace(/^\s+|\s+$/gm, "")
        .toLowerCase()
        .trim();
    },
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <li class="menu-title">Menu</li>

      <li>
        <a href="/dashboard">
          <span>Dashboards</span>
        </a>
      </li>

      <li class="menu-title">Setting</li>

      <li v-for="menu in menus" v-bind:key="menu.id" :id="'li_' + menu.id">
        <a
          href="javascript: void(0);"
          v-bind:class="[ subMenuLength[menu.id] > 0 ? 'has-arrow' : '' ]"
        >
          <i :class="'bx'+' '+menu.icon"></i>
          <span>{{ menu.display_name }}</span>
        </a>
        <ul class="sub-menu" aria-expanded="true">
          <li
            v-for="submenu in submenus"
            v-if="submenu.parent_id == menu.id"
            v-bind:key="submenu.id"
            :id="'subli_' + submenu.id"
          >
            <a
              v-bind:href="'/#/'+menu.display_name.replace(/ /g,'_').toLowerCase().trim()+'/'+submenu.url"
              class="side-nav-link-ref"
            >{{ submenu.display_name }}</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
  <!-- Sidebar -->
</template>
<style>
.sub-menu{
    overflow-x: auto;
}
</style>
